
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"31.17","height":"31.17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 4625"}},[_c('g',{attrs:{"data-name":"Path 1752","fill":"#1a5fc9"}},[_c('path',{attrs:{"d":"M15.585 29.67c-3.762 0-7.3-1.465-9.96-4.125a13.993 13.993 0 01-4.125-9.96c0-3.762 1.465-7.3 4.125-9.96a13.993 13.993 0 019.96-4.125c3.762 0 7.3 1.465 9.96 4.125a13.993 13.993 0 014.125 9.96c0 3.762-1.465 7.3-4.125 9.96a13.993 13.993 0 01-9.96 4.125z"}}),_c('path',{attrs:{"d":"M15.585 3c-3.362 0-6.522 1.31-8.899 3.686A12.503 12.503 0 003 15.585c0 3.362 1.31 6.522 3.686 8.899a12.503 12.503 0 008.899 3.686c3.362 0 6.522-1.309 8.899-3.686a12.503 12.503 0 003.686-8.899c0-3.362-1.309-6.522-3.686-8.899A12.503 12.503 0 0015.585 3m0-3C24.192 0 31.17 6.978 31.17 15.585c0 8.607-6.978 15.585-15.585 15.585C6.978 31.17 0 24.192 0 15.585 0 6.978 6.978 0 15.585 0z","fill":"#fff"}})]),_c('g',{attrs:{"data-name":"Group 3869","fill":"none","stroke":"#fff","stroke-width":"3"}},[_c('path',{attrs:{"data-name":"Line 147","d":"M15.585 9.049V22.12"}}),_c('path',{attrs:{"data-name":"Line 148","d":"M22.12 15.585H9.049"}})])])])
          )
        }
      }
    